import axios from 'axios';

export const AUTH_TOKEN = 'token';

let instance = createAxiosInstance();

// 🔧 Function to create a new axios instance
function createAxiosInstance() {
  const baseURL = localStorage.getItem("conversation_logger") || process.env.REACT_APP_GATEWAY;

  const newInstance = axios.create({
    baseURL,
  });

  // Add request interceptor
  newInstance.interceptors.request.use(config => {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  // Add response interceptor
  newInstance.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status === 403) {
        localStorage.removeItem(AUTH_TOKEN);
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );

  return newInstance;
}

export const setBaseURL = (url) => {
  localStorage.setItem("conversation_logger", url);
  instance = createAxiosInstance();
};

export default instance;
